<template>
    <section class="home-page__05">
        <img class="title" src="../../assets/images/home/page05/title.png" alt="title">

        <div class="content_wrap">
            <div class="video_wrap">
                <span class="video_wrap--hor"></span>
                <span class="video_wrap--ver"></span>
                <iframe width="560" height="315" :src="`${SYSTEM_YOTUBE_URL}?controls=0`" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>

            <div class="mask_text">
                <div class="mask_text-content">
                    <img src="../../assets/images/home/page05/right icon.png" class="left_icon" alt="" @click="slide('left')">
                    <div class="mask_text-box">
                        <ul class="text_flag-box">
                            <li :class="['text_flag-dot', {'actived_dot': index -1  == textIndex}]" v-for="index in textList.length" :key="`dot-${index}`"></li>
                        </ul>
                        <transition-group  
                        tag="div"
                        :enter-class="mask_leaveClass"
                        enter-active-class="mask-active"
                        leave-active-class="mask-active"
                        :leave-to-class="mask_enterClass">
                            <img v-for="(item, index) in textList" :key="`mask_text-box-${index}`" :src="item" alt="" v-show="textIndex == index">
                        </transition-group>
                    </div>
                    <img src="../../assets/images/home/page05/right icon.png" class="right_icon" alt="" @click="slide('right')">
                </div>
            </div>
        </div>

        <scroll-bar></scroll-bar>
        <pre-login></pre-login>
        <firefly class="left-firefly" zindex="1" dir="left"></firefly>
        <firefly class="right-firefly" zindex="1" dir="right"></firefly>
    </section>
</template>

<script>
import scrollBar from "../../components/scroll-bar";
import preLogin from "../../components/pre-login";
import firefly from "../../components/firefly";

export default {
    name: "home-page05",

    components: {
        "scroll-bar": scrollBar,
        "pre-login": preLogin,
        firefly
    },
    data: () => ({
        textList: [
            require("../../assets/images/home/page05/text_01.png"),
            require("../../assets/images/home/page05/text_02.png"),
            require("../../assets/images/home/page05/text_03.png"),
            require("../../assets/images/home/page05/text_04.png"),
            require("../../assets/images/home/page05/text_05.png"),
        ],
        textIndex: 0,
        textDir: "",
        textUsed: false,
    }),
    created() {

    },
    mounted() {

    },
    watch: {

    },
    computed: {
        SYSTEM_YOTUBE_URL() {
            return this.$store.state.SYSTEM_YOTUBE_URL;
        },
        mask_enterClass() {
            return `${
                this.textDir === "right"
                    ? "mask_next-enter"
                    : "mask_pre-enter"
            }`;
        },
        mask_leaveClass() {
            return `${
                this.textDir === "right"
                    ? "mask_next-leave-to"
                    : "mask_pre-leave-to"
            }`;
        },
    },
    methods: {
        slide(dir) {
            if(this.textUsed) {
                return false;
            }
            this.textUsed = true
            this.textDir = dir;
            if(dir === 'left') {
                if (this.textIndex <= 0) {
                    this.textIndex = this.textList.length - 1;
                } else {
                    this.textIndex -= 1;
                }
            } else if(dir === 'right') {
                this.textIndex = (this.textIndex + 1) % this.textList.length;
            }
            setTimeout(() => {
                this.textUsed = false
            }, 1000);
        }
    },
};
</script>

<style lang="scss" scoped>
.home-page__05 {
    overflow: hidden;
    position: relative;
    background: url("../../assets/images/home/page05/bg.png") no-repeat center;
    background-size: cover;

    .title {
        position: absolute;
        z-index: 3;
        height: 100%;
        left: pxTorem(27px);
        opacity: 0.8;
    }
    .content_wrap {
        position: absolute;
        width: 100%;
        top: 50%;
        transform: translateY(-50%);
        z-index: 3;

        .video_wrap {
            width: pxTorem(792px);
            height: pxTorem(443px);
            background: #000;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            margin-bottom: pxTorem(30px);

            &--hor {
                &::before {
                    content: "";
                    position: absolute;
                    background: url("../../assets/images/home/video_border.png") no-repeat;
                    background-size: cover;

                    top: 0;
                    left: 0;
                    right: 0;
                    height: pxTorem(5px);
                    background-position: 50% top;
                }
                &::after {
                    content: "";
                    position: absolute;
                    background: url("../../assets/images/home/video_border.png") no-repeat;
                    background-size: cover;

                    bottom: 0;
                    left: 0;
                    right: 0;
                    height: pxTorem(5px);
                    background-position: 50% 100%;
                }
            }

            &--ver {
                &::before {
                    content: "";
                    position: absolute;
                    background: url("../../assets/images/home/video_border.png") no-repeat;
                    background-size: cover;

                    top: pxTorem(1px);
                    bottom: pxTorem(1px);
                    left: 0;
                    width: pxTorem(4px);
                    background-position: 0 0;
                }
                &::after {
                    content: "";
                    position: absolute;
                    background: url("../../assets/images/home/video_border.png") no-repeat;
                    background-size: cover;

                    top: pxTorem(1px);
                    bottom: pxTorem(1px);
                    right: 0;
                    width: pxTorem(4px);
                    background-position: 100% 0;
                }
            }

            iframe {
                width: 100%;
                height: 100%;
            }
        }
        .mask_text {
            width: 100%;
            height: pxTorem(230px);
            background: rgba(0, 0, 0, 0.55);
            position: relative;
            display: flex;
            justify-content: center;

            .mask_text-content {
                width: 55%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;

                .left_icon {
                    transform: scale(-1, 1);
                    cursor: pointer;
                }
                .right_icon {
                    cursor: pointer;
                }
                .mask_text-box {
                    width: 90%;
                    height: 100%;
                    display: flex;
                    position: relative;
                    overflow: hidden;

                    img {
                        position: absolute;
                        height: 80%;
                        top: 0;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        margin: auto;
                    }

                    .text_flag-box {
                        display: flex;
                        flex-direction: row;
                        position: absolute;
                        left: 50%;
                        transform: translateX(-50%);
                        top: 41%;
                        justify-content: center;
                        align-items: center;

                        .text_flag-dot {
                            width: pxTorem(5px);
                            height: pxTorem(5px);
                            background: #fff;
                            border-radius: 50%;

                            &:not(:last-child) {
                                margin-right: pxTorem(10px);
                            }

                            &.actived_dot {
                                width: pxTorem(7px);
                                height: pxTorem(7px);
                            }
                        }
                    }
                }
            }
        }
    }

    .mask-active {
        transition: all 1s ease;
    }
    .mask_next-enter {
        opacity: 0;
        transform: translateX(-100%);
    }
    .mask_next-leave-to {
        opacity: 0;
        transform: translateX(100%);
    }
    .mask_pre-enter {
        opacity: 0;
        transform: translateX(100%);
    }
    .mask_pre-leave-to {
        opacity: 0;
        transform: translateX(-100%);
    }
}
</style>
